// src/shared/components/table/components/ReactTableXLSXDownload.js
import React from 'react';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { Button } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';

export const ReactTableXLSXDownload = ({ csvData = [], fileName = 'report', title = 'Report' }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const handleDownload = () => {
        if (!csvData || !csvData.length) return;

        const todayDate = new Date().toLocaleDateString("en-GB").replace(/\//g, '-');

        // Headers
        const headers = Object.keys(csvData[0]).map(key =>
            key.replace(/([a-z])([A-Z])/g, "$1 $2")
                .replace(/\b\w/g, char => char.toUpperCase())
        );

        // Convert data with formatted headers
        const formattedData = csvData.map(row => {
            const newRow = {};
            Object.keys(row).forEach(key => {
                const formattedKey = key.replace(/([a-z])([A-Z])/g, "$1 $2")
                    .replace(/\b\w/g, char => char.toUpperCase());
                newRow[formattedKey] = row[key];
            });
            return newRow;
        });

        const ws = XLSX.utils.json_to_sheet(formattedData);

        // Auto-fit columns
        const colWidths = Object.keys(formattedData[0]).map(key => ({
            wch: Math.max(
                key.length + 2,
                ...formattedData.map(r => String(r[key] ?? '').length + 2)
            )
        }));
        ws['!cols'] = colWidths;

        const wb = { Sheets: { 'Data': ws }, SheetNames: ['Data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blob, `${fileName}_${todayDate}${fileExtension}`);
    };

    return (
        <Button
            variant="contained"
            size="small"
            color="success"
            startIcon={<DescriptionIcon />}
            onClick={handleDownload}
            sx={{ fontWeight: 'bold', borderRadius: '4px', textTransform: 'none' }}
        >
            Excel
        </Button>
    );
};

export default ReactTableXLSXDownload;
